import { Link, useLocation } from 'react-router-dom';
import { routes } from '../routes/routeConfig';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const location = useLocation();

    const privatePaths = Object.values(routes.private);
    const isDashboardContext = privatePaths.some((path) => location.pathname.startsWith(path));
    const footerClassName = isDashboardContext ? 'app-footer app-footer--dashboard' : 'app-footer';

    return (
        <footer className={footerClassName}>
            <div className='app-footer__content'>
                <div className='app-footer__brand'>
                    <span className='title'>CICLII</span>
                    <div className='app-footer__copy'>
                        &copy; {currentYear} CICLII. Acompañando cada ciclo con ciencia y empat&iacute;a.
                    </div>
                </div>
                <nav className='app-footer__links'>
                    <Link to={routes.public.terms}>T&eacute;rminos</Link>
                    <span className='app-footer__separator' aria-hidden='true'>|</span>
                    <Link to={routes.public.privacy}>Privacidad</Link>
                    {!isDashboardContext && (
                        <>
                            <span className='app-footer__separator' aria-hidden='true'>|</span>
                            <Link to={routes.public.register}>Reg&iacute;strate</Link>
                        </>
                    )}
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
